<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div style="display: flex; position" class="chartAndPie">
        <div id="chart-div" class="chart-div" style="width: 70%">
          <DxToolbar>
            <DxItem
              #default
              location="before"
              locate-in-menu="never"
            >
              <div class="toolbar-label"><b>년도 : </b></div>
            </DxItem>
            <DxItem
              :options="selectBoxYearOptions"
              location="before"
              locate-in-menu="auto"
              widget="dxSelectBox"
            />
            </DxToolbar>
            <DxChart
              id="chart"
              :data-source="productChart"
              palette="Office"
              title="라인중단통계"
              class="DxChart"
            >
              <DxCommonSeriesSettings
                type="bar"
                argument-field="발생월"
              />
              <DxSeries
                v-for="cause in listOfCauses"
                :key="cause.value"
                :value-field="cause.value"
                :name="cause.value"
              />
              <DxCommonAxisSettings>
                <DxGrid :visible="true"/>
              </DxCommonAxisSettings>
              <DxValueAxis
                name="amount"
                position="left"
              />
              <DxMargin :bottom="20"/>
              <DxArgumentAxis
                :allow-decimals="false"
                :axis-division-factor="30"
              >
                <DxLabel>
                  <DxFormat type="decimal"/>
                </DxLabel>
              </DxArgumentAxis>
              <DxLegend
                vertical-alignment="bottom"
                horizontal-alignment="center"
              />
              <DxExport
                :enabled="true"
                title="연생산현황"
                />
              <DxTooltip
                :enabled="true"
                :shared="false"
              />
              <!-- <DxSize width="100%"/> -->
            </DxChart>
          </div>
          <div class="pie-div">
            <DxPieChart
              id="pie"
              :data-source="pieChartData"
              class="pie-chart"
              palette="Office"
              :title="thisYear+'년 원인별 중단 통계'"
              type="doughnut"
            >
              <DxPieSeries
                argument-field="원인명"
                value-field="평균소요시간"
              >
                <DxPieLabel :visible="true" :customize-text="formatLabel">
                  <DxPieConnector
                    :visible="true"
                    :width="1"
                  />
                </DxPieLabel>
              </DxPieSeries>
              <DxPieSize :width="pieWidth"/>
              <DxPieExport :enabled="true"/>
            </DxPieChart>
          </div>
      </div>
      <div>
        <DxToolbar class=‘select-group’ style=‘margin-left:0;’>
          <DxItem
            #default
            location=“after”
            locate-in-menu=“never”
          >
            <div class=“toolbar-label” style=‘color:red;’>(단위:시간)</div>
          </DxItem>
        </DxToolbar>
        <DxPivotGrid
          ref="refPivot"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :show-borders="true"
          :show-column-grand-totals="false"
          :show-row-grand-totals="true"
          :show-row-totals="false"
          :show-column-totals="true"
          :data-source="dataSource"
          @cell-prepared = 'onCellPrepared'
          @exporting="onExporting"
        >
          <DxFieldChooser
            :enabled="false"
            :height="400"
          />
          <DxExport
            :enabled="true"
            :file-name="excelTitle"
          />
        </DxPivotGrid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import axios from 'axios'
import DxPieChart, {
  DxSize as DxPieSize,
  DxSeries as DxPieSeries,
  DxLabel as DxPieLabel,
  DxConnector as DxPieConnector,
  DxExport as DxPieExport
} from 'devextreme-vue/pie-chart'
import {
  DxChart,
  DxSeries,
  DxValueAxis,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxCommonAxisSettings,
  DxGrid,
  // DxSize,
  DxExport,
  DxLegend,
  DxMargin,
  DxTooltip,
  DxLabel,
  DxFormat
} from 'devextreme-vue/chart'
import { DxPivotGrid, DxFieldChooser
// , DxExport
} from 'devextreme-vue/pivot-grid'
// import { DxTooltip } from 'devextreme-vue/tooltip'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
// import { DxButton } from 'devextreme-vue'
// excel export 관련 lib
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportPivotGrid } from 'devextreme/excel_exporter'

export default {
  name: 'ProductChart',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '연중단현황'
        }
      ],
      productChart: [],
      selectBoxYearOptions: null,
      selectBoxMonthOptions: null,
      thisYear: null,
      monthlyData: [],
      dataSource: null,
      excelTitle: null,
      pivotGirdData: [], //
      pieChartData: [], //
      resultSum: null,
      planSum: null,
      listOfCauses: [], // Series 생성을 위한 변수
      chartWidth: null,
      totalTime: null, // PieChart % 비율계산을 위한 변수
      pieWidth: 400
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxChart,
    DxValueAxis,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxCommonAxisSettings,
    DxGrid,
    DxExport,
    // DxSize,
    DxLegend,
    DxMargin,
    DxTooltip,
    DxLabel,
    DxFormat,
    DxToolbar,
    DxItem,
    DxPivotGrid,
    DxFieldChooser,
    // pie
    DxPieChart,
    DxPieSize,
    DxPieSeries,
    DxPieLabel,
    DxPieConnector,
    DxPieExport
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.init()
  },
  mounted () {
    this.pieWidth = this.$Q('.chartAndPie').width() * 0.3
    window.addEventListener('resize', this.handleResize)
  },
  updated () {
  },
  beforeDestroy: function () {
  },
  methods: {
    handleResize (e) {
      this.pieWidth = this.$Q('.chartAndPie').width() * 0.3
    },
    /* ==============START EXCEL EXPORT============ */
    onExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.excelTitle)
      exportPivotGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ pivotCell, excelCell }) => {
          if (excelCell._value.model.value === 0) {
            excelCell._value.model.value = ''
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.excelTitle}.xlsx`)
        })
      })
      e.cancel = true
    },
    /* ==============END EXCEL EXPORT============ */
    calculateDowntime (diff) {
      if (diff !== null && diff !== undefined) {
        return `${(diff / 60).toFixed(1)}시간`
      }
    },
    formatLabel (timeRate) {
      return `${timeRate.percentText}`
    },
    getDate (date) {
      return AppLib.formatDateTimeFromTimeStamp(date)
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.thisYear = args.value
          this.refreshPivotGrid(this.thisYear)
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      // makeMonth 할때 사용
      this.selectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.selectedMonth,
        onValueChanged: (args) => {
          this.selectedMonth = args.value
          this.refreshPivotGrid(this.thisYear)
        }
      }
      this.refreshPivotGrid(this.thisYear)
    },
    onToolbarPreparing (e) {
      //
    },
    onCellPrepared (e) {
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        } else {
          this.$Q(e.cellElement).find('span').text(this.calculateDowntime(e.cell.value))
        }
      }
    },
    refreshPivotGrid (year) {
      const param = { fromDate: `${year}-01-01`, toDate: `${year}-12-31 23:59:59` }
      const pivotAndChartData = this.$_sp.runNoEncodeFindProc('spFindAll라인중단ByDate', param)
      const pieChartData = this.$_sp.runNoEncodeFindProc('spFindAll라인중단ByDateGbyCause', param)
      this.excelTitle = `${year}년 중단현황`
      axios.all([pivotAndChartData, pieChartData])
        .then(axios.spread((...reponse) => {
          this.pivotGirdData = this.$_.sortBy(this.$_sp.MakeModel(reponse[0]), '발생월')
          this.pieChartData = this.$_sp.MakeModel(reponse[1])
          console.log(this.pivotGirdData)
          if (this.pivotGirdData.length > 0) {
            this.makeMonthly(this.pivotGirdData)
            this.setInitDataSource()
            this.makeChartData()
          } else {
            this.pivotGirdData = []
            this.productChart = []
            this.dataSource = []
          }
        })
        )
    },
    makeChartData () {
      this.productChart = []
      let timeStamp
      let 원인 = this.$store.getters.getBaseDataByType(ConstDef.라인중단코드)
      this.listOfCauses = []
      for (var i in 원인) {
        this.listOfCauses.push({ value: 원인[i].코드명 })
      }
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        this.productChart.push({ 발생월: `${timeStamp.split('-')[1]}월` })
        for (let j = 0; j < 원인.length; j++) {
          let where = this.$_.findWhere(this.pivotGirdData, { 발생월: timeStamp, 원인명: 원인[j].코드명 })
          if (where !== undefined && where.평균소요시간 !== undefined) {
            let temp
            temp = {
              발생월: `${timeStamp.split('-')[1]}월`,
              라인명: where.라인명,
              라인코드: where.라인코드,
              [where.원인명]: where.평균소요시간
            }
            this.productChart.push(temp)
          }
        }
      }
      console.log(this.productChart)
      this.productChart = this.$_.sortBy(this.productChart, '발생월')
    },
    makeMonthly (pivotGirdData) {
      this.totalTime = (this.pivotGirdData).reduce((s, f) => s + f.평균소요시간, 0)
      let timeStamp
      for (let i in this.pivotGirdData) {
        this.pivotGirdData[i].평균소요시간비율 = (this.pivotGirdData[i].평균소요시간 / this.totalTime)
      }
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        let where = this.$_.findWhere(pivotGirdData[0], { 발생일: timeStamp })
        if (where === undefined) {
          const temp = {
            원인명: pivotGirdData[0].원인명,
            라인코드: pivotGirdData[0].라인코드,
            발생월: timeStamp
          }
          pivotGirdData.push(temp)
        }
      }
    },
    setInitDataSource () {
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '그룹',
            dataField: '원인명',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            dataField: '발생월',
            dataType: 'date',
            area: 'column',
            groupInterval: 'year',
            expanded: true
          },
          {
            dataField: '발생월',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            caption: '소요시간',
            dataField: '평균소요시간',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }
        ],
        store: this.pivotGirdData
      })
    }
  }
}
</script>

<style lang="scss">
 .pie-div {
   padding-top: 28px
 }
</style>
